import React from 'react';
import styled from 'styled-components';
import { contact, phone_bg } from '../images/Mobile';

const Wrapper = styled.div`
    width: 100vw;
    position: relative;

    .bg {
        max-height: 200px;
        width: 100%;
    }

    .contact {
        width: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;

const MobileSection5 = () => {
    return (
        <Wrapper>
            <img className='bg' src={phone_bg} alt='' />
            <img className='contact' src={contact} />
        </Wrapper>
    );
};

export default MobileSection5;
